import Controller from "./manualInvoiceItems.controller";
import template from "./manualInvoiceItems.html";

const manualInvoiceItems = {
  template,
  controller: Controller,
};

export default manualInvoiceItems;



// WEBPACK FOOTER //
// ./src/pages/manualInvoiceItems/manualInvoiceItems.component.js